import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, inject, ViewChild } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import { Router } from '@angular/router';
import { AutoLogoutService } from '../../services/autoLogout.service';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { ToastService } from '../../services/toast.service';
import { ToastType } from '../../enums/config.enum';
import { IndicationQuoteStepService } from '../../services/indicationQuoteStep.service';
import { PeriodicAPICallService } from '../../services/periodic-apicall.service';
import { NavigationHandlerService } from '../../services/navigationHandler.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  toastService = inject(ToastService);
  indicationService = inject(IndicationQuoteStepService);
  authService = inject(AuthService)
  @ViewChild('notificationMenu', { static: false })
  closeTimeout: any;
  notificationMenu!: ElementRef;

  constructor(private router: Router, private autoLogoutService: AutoLogoutService, private navigationHandler: NavigationHandlerService) {}

  menuOpen = false;
  role: number | null = null;
  fullName: string = '';
  email: string = '';
  roleName: string = '';
  initials: string = '';
  notificationsOpen = false;
  periodicApiService = inject(PeriodicAPICallService);
  
  
  ngOnInit(): void {
    const storedRole = sessionStorage.getItem('role');
    this.role = storedRole ? parseInt(storedRole, 10) : null;

    const userDetails = JSON.parse(sessionStorage.getItem('userDetails') || '{}');
    const userEmail = sessionStorage.getItem('userEmail');

    const firstName = userDetails.firstName || ''; 
    const lastName = userDetails.lastName || '';
    if (firstName && lastName) {
      this.initials = `${firstName.charAt(0).toUpperCase()} ${lastName.charAt(0).toUpperCase()}`;
    }

    this.fullName = userDetails.fullName || 'Unknown User';
    this.email = userEmail || 'No Email';
    this.roleName = userDetails.roleName || 'User';

  }

  isUwAdmin(): boolean {
    return this.role === 2;
  }

  isSysAdmin(): boolean {
    return this.role === 3;
  }

  isBroker(): boolean {
    return this.role === 1;
  }

  openMenu() {
    this.menuOpen = true;
  }
  
  closeMenu() {
    this.menuOpen = false;
  }
 
  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }
  
  @HostListener('document:click', ['$event'])
  handleClickOutside(event: Event) {
    const target = event.target as HTMLElement;
    if (!target.closest('#au_header_user_menu_toggle')) {
      this.menuOpen = false;
    }
  }

  @HostListener('document:click', ['$event'])
  handleClick(event: Event) {
    const target = event.target as HTMLElement;
    if (!target.closest('notification_bell')) {
      this.menuOpen = false;
    }
  }

  toggleNotifications() {
    this.notificationsOpen = !this.notificationsOpen;
  }
  
  openNotifications() {
    this.notificationsOpen = true;
  }

  closeNotifications() {
    // delay the close, so the user can move the mouse into the menu.
    setTimeout(() => {
        this.notificationsOpen = false;
    }, 200);
  }

    @HostListener('document:click', ['$event'])
    clickout(event: { target: any; }) {
        if(this.notificationMenu && !this.notificationMenu.nativeElement.contains(event.target) && this.notificationsOpen) {
            this.notificationsOpen = false;
        }
    }

  logOut() {
    const userId = this.authService?.getUserDetailsFromStorage()?.userDetails?.userId;
    const token = this.authService.getToken();
    if(userId && token){
      this.authService.logout(token, userId).subscribe({
        next: (response: HttpResponse<any>) => {
          if (response) {
            this.periodicApiService.stopPeriodicApiCall();
            this.autoLogoutService.clearTimerOnLogout();
            this.authService.cleanUpStorageData().subscribe({
              next: () => {
                this.authService.setIsLogoutClicked(true);
                this.toastService.addNotification({
                  message: 'You have successfully logged out!',
                  type: ToastType.Success,
                });
                this.router.navigate(['/login'], { replaceUrl: true });
              },
            });
          }
        },
        error: (error: HttpErrorResponse) => {
          this.authService.setLoading(false);
          this.toastService.addNotification({message: "System error. Failed to logout. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
        }
      });
    }

  }

  navigate(){
    
    if(this.isSysAdmin()){
      this.router.navigate(['/system-admin']);
      this.indicationService.removeIndicationQuoteStorageData();
    }else{
      // If in Request Quote flow, let it handle context-aware save & exit; else go to quotes
      if (this.navigationHandler.isInRequestQuote()) {
        this.navigationHandler.emitLogoClick();
      } else {
        this.indicationService.removeIndicationQuoteStorageData();
        this.router.navigate(['/quote']);
      }
    }
  }

  moveToPolicyDocument() {
    this.router.navigate(['/policy-document']);
  }
}
